import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Page, Header } from 'components'
import { useCargoService } from 'hooks/useCargoService'

import { Results } from './components'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'
import useRouter from 'utils/useRouter'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const Cargos = (props) => {
  const { route } = props
  const router = useRouter()
  const cargoService = useCargoService()
  const classes = useStyles()
  const processandoCargos = useSelector((state) => state.cargos.processandoCargos)

  const cargos = useSelector((state) => state.cargos.cargos)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    cargoService.listarCargosGlobal()
   
  }, [])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header
        titulo={`${route.secao}`}
        overline={route.secao}
        textoBotao="Cadastrar novo"
        linkBotao={`${route.path}/cadastrar`}
      />
      {cargos && !processandoCargos && <Results className={classes.results} dados={cargos} />}
    </Page>
  )
}
